import { gql } from "../../../../../gql/__generated__/gql";

export const CHANGE_PASSWORD = gql(`
  mutation changePassword($confirmationToken: String!, $password: String!, $email: String!) {
    changePassword(confirmationToken: $confirmationToken, password: $password, email: $email)
  }
`);

export const CONFIRM_EMAIL = gql(`
  mutation confirmEmail($email: String!, $confirmationToken: String!) {
    confirmEmail(email: $email, confirmationToken: $confirmationToken)
  }
`);

export const RESEND_CONFIRMATION_EMAIL = gql(`
  mutation resendConfirmationEmail($email: String!) {
    resendConfirmationEmail(email: $email)
  }
`);
